<template>
  <div class="switch-wrapper">
    <div class="left-top-corner">
      <svg v-if="!isChecked" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 0.5L1.50016 0.5" stroke="#C7C8D1"/>
        <path d="M1 0L1 6" stroke="#C7C8D1"/>
      </svg>
      <svg v-else width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 0.5L1.50016 0.5" stroke="#E0C522"/>
        <path d="M1 0L1 6" stroke="#E0C522"/>
      </svg>
    </div>
    <div class="left-bottom-corner">
      <svg v-if="!isChecked" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 5.5L1.50016 5.5" stroke="#C7C8D1"/>
        <path d="M1 6L1 0" stroke="#C7C8D1"/>
      </svg>
      <svg v-else width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 5.5L1.50016 5.5" stroke="#E0C522"/>
        <path d="M1 6L1 0" stroke="#E0C522"/>
      </svg>
    </div>
    <div class="right-top-corner">
      <svg v-if="!isChecked" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" y1="0.5" x2="6.01351" y2="0.5" stroke="#C7C8D1"/>
        <path d="M6 0L6 6" stroke="#C7C8D1"/>
      </svg>
      <svg v-else width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" y1="0.5" x2="6.01351" y2="0.5" stroke="#E0C522"/>
        <path d="M6 0L6 6" stroke="#E0C522"/>
      </svg>
    </div>
    <div class="right-bottom-corner">
      <svg v-if="!isChecked" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 5.5L5.51351 5.5" stroke="#C7C8D1"/>
        <path d="M6 6L6 0" stroke="#C7C8D1"/>
      </svg>
      <svg v-else width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 5.5L5.51351 5.5" stroke="#E0C522"/>
        <path d="M6 6L6 0" stroke="#E0C522"/>
      </svg>
    </div>
    <div class="switch" :class="{ 'switch--on': isChecked }" @click="toggle">
      <div class="switch__handle">
        <span v-if="isChecked" class="on">on</span>
        <span v-else class="off">off</span>
      </div>
    </div>
  </div>
  </template>

  <script>
  export default {
    name: "Switch",
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      isChecked() {
        return this.modelValue;
      },
    },
    methods: {
      toggle() {
        this.$emit("update:modelValue", !this.isChecked);
      },
    },
  };
  </script>

<style scoped>
  .switch-wrapper {
        width: 55px;
    height: 30px;

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    & > .left-top-corner {
      position: absolute;
      top: -7.5px;
      left: -1.5px;

      height: 6px;
    }

    & > .left-bottom-corner {
      position: absolute;
      bottom: -5px;
      left: -1.5px;
    }

    & > .right-top-corner {
      position: absolute;
      top: -7.5px;
      right: -1.5px;
    }

    & > .right-bottom-corner {
      position: absolute;
      bottom: -5px;
      right: -1.5px;
    }

  }

  .switch {
    width: 50px;
    height: 25px;
    background-color: #2c2b33;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
  }

    .switch__handle {
    width: 19px;
    height: 14px;
    background-color: #C7C8D1;
    position: absolute;
    top: 50%;
    left: 6px;
    transition: left 0.3s;
    font-size: 7px;
    transform: translateY(-50%);

    & > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      color: #1B1C22;
    }

  }

  .switch--on .switch__handle {
    left: 26px;
    background-color: #E0C522;
  }
</style>
